import MicroModal from 'micromodal';

// Run the functions on document ready
document.addEventListener('DOMContentLoaded', () => {
    MicroModal.init({ disableScroll: true });
});

const closeOpenModals = (): void => {
    const modals = document.querySelectorAll('.modal');
    modals.forEach(element => {
        if (element.classList.contains('is-open')) {
            const hiddenClose = element.querySelector('.hidden-close');
            if (hiddenClose) {
                (hiddenClose as HTMLDivElement).click();
            }
        }
    });
};

// Due to the mobile touch bug that exists in the MicroModal lib, we had to use the below
// to handle close modal function, the main point here is the stopPropagation on the click event
// eslint-disable-next-line @typescript-eslint/no-explicit-any
document.body.addEventListener('click', (evt: any) => {
    // console.info('evt target', evt.target);
    // console.info('evt target', typeof evt.target?.className, evt.target?.className);
    if (typeof evt.target?.className === 'string') {
        if (evt.target?.className.includes('modal-overlay') || evt.target?.className.includes('modal-close')) {
            evt.preventDefault();
            evt.stopPropagation();
            closeOpenModals();
        }
    }
}, false);

document.body.addEventListener('keydown', (evt: KeyboardEvent) => {
    if (typeof (evt.target as HTMLElement)?.className === 'string') {
        if ((evt.key === 'Enter' && (evt.target as HTMLElement)?.className.includes('modal-close')) || evt.key === 'Escape') {
            evt.preventDefault();
            evt.stopPropagation();
            closeOpenModals();
        }
    }
}, false);
